
import moment from 'moment'
import UserSetting from '@/utils/userSetting'

export default () => ({
  isLoading: false,
  isLoadingMore: false,
  isUpdating: false,
  isFiltersLoaded: false,
  isFiltersApplied: true,
  isFiltersDisabled: false,
  isFavoriteLoading: false,
  isEmptySearchResult: false,
  searchFailed: false,
  showForm: false,
  showSearch: true,
  errors: [],
  collection: [],
  collectionFilters: {
    meals: [],
    categories: [],
    beach: [],
    bestFor: [],
    currencies: [],
    distance: {
      maxDistance: 75
    },
    facilities: [],
    hotelType: [],
    price: {
      minPrice: 0,
      maxPrice: 0
    },
    regionsSet: [],
    roomFacilities: [],
    sportEntertainment: []
  },
  minPrices: {
    categories: [],
    meals: []
  },
  agencyPrice: false,
  viewType: UserSetting.getViewType(),
  dictionaries: {
    categories: [],
    meals: [],
    currencies: []
  },
  form: {
    locations: {
      place: {
        slug: null,
        name: null,
        badge: null
      },
      country: {
        slug: null,
        name: null,
        badge: null
      },
      region: {
        slug: null,
        name: null,
        badge: null
      },
      hotel: {
        slug: null,
        name: null,
        badge: null
      },
    },
    placeId: null,
    placeType: 'Region',
    placeName: null,
    rooms: [
      {
        adults: 2,
        children: 0,
        ages: []
      }
    ],
    duration: 7,
    checkInDate: moment().add(15, 'days').format('DD.MM.YYYY'),
    hasMore: 1,
    page: 1,
    perPage: 10,
    hotelSearchId: null,
    currency: 'RUB',
    priceSort: 'ascending',
    showAdditionalForm: 0
  },
  formErrors: [],
  filters: {
    regions: [],
    hotelsId: [],
    meals: [],
    bestFor: [],
    category: [],
    facts: [],
    ratingFrom: 0,
    ratingTo: 100,
    priceFrom: 0,
    priceTo: 500000,
    distanceFrom: 0,
    distanceTo: 75,
  },
  pagination: {
    page: 1,
    perPage: 10,
    lastPage: 1,
    total: 0
  }
})
